import React, { FC, useMemo } from 'react';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faArrowTrendDown } from '@fortawesome/free-solid-svg-icons/faArrowTrendDown';
import { faArrowTrendUp } from '@fortawesome/free-solid-svg-icons/faArrowTrendUp';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import styles from './rankCardStyles.scss';

const RankCardDeltaBadge: FC<{
  viewDeltaString: string;
}> = ({ viewDeltaString }) => {
  const deltaDirection = viewDeltaString?.split(' ')[0];

  const { down, holding, recent, up } = useMemo(
    () => ({
      down: deltaDirection === 'Down',
      holding: deltaDirection === 'Holding',
      recent: deltaDirection === 'Recently',
      up: deltaDirection === 'Up'
    }),
    [deltaDirection]
  );

  return (
    <div
      className={classNames(styles.rankCardDeltaBadge, {
        [styles.down]: down,
        [styles.holding]: holding,
        [styles.recent]: recent,
        [styles.up]: up
      })}
    >
      {down ? <FontAwesomeIcon icon={faArrowTrendDown} /> : null}
      {holding ? <FontAwesomeIcon icon={faArrowRight} /> : null}
      {recent ? <FontAwesomeIcon icon={faPlus} /> : null}
      {up ? <FontAwesomeIcon icon={faArrowTrendUp} /> : null}
      {viewDeltaString}
    </div>
  );
};

export default RankCardDeltaBadge;
